import { type ComponentProps, type FC } from 'react';
import { cn } from '../lib/utils';
import {
  Collapsible as ShadcnCollapsible,
  CollapsibleContent as ShadcnCollapsibleContent,
  CollapsibleTrigger as ShadcnCollapsibleTrigger,
} from './ui/collapsible';

type CollapsibleProps = ComponentProps<typeof ShadcnCollapsible>;
type CollapsibleContentProps = ComponentProps<typeof ShadcnCollapsibleContent>;
type CollapsibleTriggerProps = ComponentProps<typeof ShadcnCollapsibleTrigger>;

export const Collapsible: FC<CollapsibleProps> = (props) => {
  return <ShadcnCollapsible {...props} />;
};

export const CollapsibleTrigger: FC<CollapsibleTriggerProps> = (props) => {
  return <ShadcnCollapsibleTrigger {...props} />;
};

/**
 * CollapsibleContent component with custom animations for open and close states.
 */
export const CollapsibleContent: FC<CollapsibleContentProps> = ({ className, ...props }) => {
  return (
    <ShadcnCollapsibleContent
      className={cn(
        'overflow-hidden',
        'data-[state=open]:animate-[slideDown_300ms_ease-out]',
        'data-[state=closed]:animate-[slideUp_300ms_ease-out]',
        'will-change-[height]',
        className,
      )}
      {...props}
    />
  );
};
